/*
 * @Author: shannyHuang
 * @Date: 2022-06-01 11:29:46
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2023-08-02 10:13:46
 * @FilePath: \wemeet-web-activity\src\pages\auth-page-config.ts
 */

/**
 * 配置不需要强制登录的页面，如果没有登录会直接跳转登录页
 */
export const NO_NEED_LOGIN_PAGES = [
  '/middle-login',
  '/space',
  '/app-launch',
  '/no-permission',
  '/space/share',
  '/service-worker/webview-startup',
  '/event/[eventid]/registration', // 报名页无需登录验证
  '/canvas-poster',
  '/payback',
  '/share-poster',
  '/replay', // 回放页无需登录验证
  '/404',
  // '/home',
];

/** 能在移动端非会议app里打开的页面，不在名单页面只能在手机app里打开 */
export const CAN_OPEN_OUTSIDE_MOBILE_APP = [
  '/middle-login',
  '/space',
  '/app-launch',
  '/event/[eventid]/registration',
  '/canvas-poster',
  '/payend',
  '/myticket',
  '/tickets/[eventId]',
  '/payback',
  '/coupon/[couponId]',
  '/quick-buy/[eventId]',
  '/invite',
  '/share-poster',
  '/space/share',
  '/replay',
];

// 不需要开通白名单
export const NO_NEED_PERMISSION = [
  '/event/[eventid]/registration',
  '/payend',
  '/myticket',
  '/tickets/[eventId]',
  '/payback',
  '/replay',
  '/no-permission',
  '/coupon/[couponId]',
  '/quick-buy/[eventId]',
  '/invite',
  '/space',
  '/space/share',
  '/host-buy',
  '/name-auth',
  '/app-launch',
];
// 主办方管理页面
export const HOST_ADMIN = [
  '/index',
  '/home',
  '/fans',
  '/pay-qualification',
  '/personal',
  '/service-order',
  '/coupon',
  '/member',
  '/record-playback',
  '/income/order-management',
  '/income/withdraw',
  '/income/manage-settle-in',
];
// 不需要活动空间权限页面
export const NO_NEED_SHOW_AXTIVITY_ROOM = ['/create', '/host-buy', '/name-auth'];

// 可首屏访问的页面处理
export const VIEW_IN_FIRST_PAGE = [
  '/event/[eventid]/registration',
  '/payback',
  '/share-poster',
  '/replay',
  '/host-buy',
  '/name-auth',
];

// 一直显示移动端头的页面
export const ALWAYS_SHOW_MOBILE_HEAD = ['/quick-buy/[eventId]'];
